module.exports = __webpack_public_path__ + "img/1d79c276a98e4369f80906a7753e46ca.0ca50f31.png";